﻿import {translation} from "@2d-front-monorepo/core";
import {MvvmValidation} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {useMemo} from "react";
import {EMAIL} from "../regex";

export default function useEmailRequiredPolicy(): MvvmValidation<string> {
	return useMemo<MvvmValidation<string>>(() => ({
		required: translation(PermitTranslations.validation__email__required),
		validate: function (email: string | undefined): string | undefined {
			const notNullEmail = email ?? "";
			if (notNullEmail.length > 50) {
				return translation(PermitTranslations.validation__email__length);
			}

			if (EMAIL.test(notNullEmail)) {
				return undefined;
			}

			return translation(PermitTranslations.validation__email__invalid);
		}
	}), []);
}
